import React, {Component} from "react";
import {Redirect, Route} from 'react-router-dom';

class PrivateRoute extends Component {
    render() {
        const {component: Component, user, ...rest} = this.props;
        const isAuthorized = user && user.token;
        let componentToRender = <Component {...this.props} />;

        if (!isAuthorized
            || isAuthorized === ''
            || isAuthorized === 'null'){
            return <Redirect to={{
                pathname: "/login",
                state: {from: this.props.location}
            }}/>
        }
        return (
            <Route
                {...rest}
                render={props => {
                    return componentToRender
                }}
            />
        );
        
    }
}

export default PrivateRoute;



// WEBPACK FOOTER //
// ./src/components/components/private-route/private-route.js